import React, {Component} from "react";
import i18n from "../../../i18nextInitiator";
import {AppBar, Toolbar} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from '@material-ui/icons/Menu';
import {compose} from "redux";
import {connect} from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import LogoAndPhone from "./LogoAndPhone";
import ArrowBack from '@material-ui/icons/ArrowForwardIos';
import Snackbars from "./Snackbars/Snackbars";
import DrawerMenu from "./DrawerMenu";
import {hideBackBtn, openDrawerMenu, paths, showBackBtn, handleGoBack} from "../../../actions/actionCreators";
import {withRouter} from "react-router-dom";

/**
 * The Specific translate function for this namespace
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');
/**
 * JSS
 * @param theme
 * @returns {{root: {backgroundColor: string, position: string}, menuButton: {color: string}}}
 */
const styles = (theme) => ({
    root: {
        position: "relative",
        backgroundColor: "#FFF",
        borderRadius: "unset !important"
    },
    menuButton: {
        color: "#000",
    },
    logoPhoneElement: {
        margin: "auto",
    },
    toolbar:{
        maxWidth: 600,
        padding: "0 20px",
        margin: 'auto'
    }
});

/**
 * Redux States.
 * @param state
 */
const mapStateToProps = state => ({...state});

class Header extends Component {

    componentDidUpdate(prevProps, prevState, snapshot) {

        const {
            props: {
                location: {
                    pathname
                }
            }
        } = this

        const {
            location: {
                pathname: prevPathName
            }
        } = prevProps

        /**
         * url paths that should have back button
         * @type {(string)[]}
         */
        const pathsWithBackBtn = [
            paths.selectDestination,
            paths.order,
            paths.invoice,
        ]

        if (pathname !== prevPathName)
            if (pathsWithBackBtn.includes(pathname))
                showBackBtn()
            else
                hideBackBtn()
    }

    render() {
        const {
            classes,
            order: {
                showBackBtn,
                hideHeader
            }
        } = this.props

        return <>
            <AppBar hidden={hideHeader} className={classes.root}>
                <Toolbar>
                    <Grid container justifyContent={"space-between"} className={classes.toolbar}>

                        {
                            showBackBtn ?
                                <IconButton onClick={()=>handleGoBack()}>
                                    <ArrowBack/>
                                </IconButton>
                                :
                                <IconButton onClick={openDrawerMenu} className={classes.menuButton}>
                                    <MenuIcon/>
                                </IconButton>
                        }

                        <LogoAndPhone/>
                    </Grid>
                </Toolbar>
            </AppBar>

            <DrawerMenu/>
            <Snackbars/>
        </>
    }
}

export default compose(withRouter, connect(mapStateToProps), withStyles(styles))(Header)